import { Common } from '@thecvlb/design-system';
import { IconProps } from '@thecvlb/design-system/lib/src/common/Icon';

import { ButtonAuthWithProps } from './buttonAuthWith.types';

const ButtonAuthWith: React.FC<ButtonAuthWithProps> = ({ provider, disabled, onClick }) => {
  const icons: { [key: string]: IconProps['name'] } = {
    apple: 'logo-apple',
    email: 'email',
    google: 'logo-google'
  };

  const labels = {
    apple: 'Continue with Apple',
    email: 'Continue with Email',
    google: 'Continue with Google'
  };

  return (
    <button
      className="flex w-full cursor-pointer items-center justify-center rounded-lg border border-gray-400 bg-white p-4 text-lg font-semibold hover:bg-gray-50 md:h-[52px] md:text-sm"
      disabled={disabled}
      onClick={onClick}
    >
      <Common.Icon className="mr-2" name={icons[provider]} />
      {labels[provider]}
    </button>
  );
};

export default ButtonAuthWith;
